import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import config from "../config";
import { Constant } from "../utils/enum";
import { toast } from "react-toastify";

const { api } = config;

axios.defaults.baseURL = api.API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";

axios.interceptors.request.use(
  (config) => {
    let token:any = localStorage.getItem(Constant.access_token);
    
    if (token && !token.startsWith("Bearer ")) {
      token = token.replace(/^"(.*)"$/, '$1').trim();
      
      token = "Bearer " + token;
      config.headers["Authorization"] = token;
    } 
    // const refreshToken = localStorage.getItem(Constant.refresh_token);
    // if (refreshToken) {
    //   config.headers["refresh-token"] = `${JSON.parse(refreshToken)}`;
    // }
    return config;
  },
  (error) => {
    // Do something with the request error
    return Promise.reject(error);
  }
);

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    const url = error?.response?.config?.url;
    if (!url) {
        console.error("URL is undefined in the response error");
        return Promise.reject(error);
      }
      if (url && url.includes("/auth/refresh")) {
        handleLogout();
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        toast.error("Bad Request - Logging out...",{ autoClose: 1000 });
        handleLogout();
          // toast.error(error.response.data.message,{ autoClose: 1000 });
        // setTimeout(() => {
        //   location.reload();
        // }, 1000);
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
        case 400:
          // localStorage.removeItem(Constant.access_token);
          // localStorage.removeItem(Constant.refresh_token);
          // toast.error("Bad Request - Logging out...");
          // window.location.reload();
          // break;
      default:
        message = error.message || error;
    }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token : any) => {
  axios.defaults.headers.common["Authorization"] =  token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url : any, params : any) => {
    let response;
    let paramKeys : any = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url: any, data: any) => {
    
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url : any, data : any) => {
    return axios.patch(url, data);
  };

  put = (url : any, data : any) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url: string, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = localStorage.getItem('user');
  const token = localStorage.getItem('access_token');
  if (!user || !token) {
    return null;
  } else {
    return {...JSON.parse(user!), token: JSON.parse(token!)};
  }
};

function handleLogout() {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = '/login';
}

export { APIClient, setAuthorization, getLoggedinUser };